export default __webpack_public_path__ + "static/media/ep6TN2.ba63c4a7.jpg";